/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S10_LinkInputs */

const tr_kullanim_s10_link = /** @type {(inputs: Kullanim_S10_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Aydınlatma Metni`)
};

const en_kullanim_s10_link = /** @type {(inputs: Kullanim_S10_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Information Notice`)
};

const de_kullanim_s10_link = /** @type {(inputs: Kullanim_S10_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK-Aufklärungsmitteilung`)
};

const ru_kullanim_s10_link = /** @type {(inputs: Kullanim_S10_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информационное уведомление KVKK`)
};

/**
* | output |
* | --- |
* | "KVKK Information Notice" |
*
* @param {Kullanim_S10_LinkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s10_link = /** @type {((inputs?: Kullanim_S10_LinkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S10_LinkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s10_link(inputs)
	if (locale === "de") return de_kullanim_s10_link(inputs)
	if (locale === "ru") return ru_kullanim_s10_link(inputs)
	return tr_kullanim_s10_link(inputs)
});